import { TranslateService } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';
import { IrisUserTimePipe } from '@iris/common/modules/time';
import { ValidationMessageResolver } from '@ngx-strakit/validation';

@Injectable()
export class SkMinDatetimeValidationMessageResolver implements ValidationMessageResolver<{ min: unknown }> {
  private readonly translate = inject(TranslateService);
  private readonly userTimePipe = inject(IrisUserTimePipe);
  readonly errorCode = 'matDatepickerMin';

  getMessage(error?: { min: unknown }): string {
    return this.translate.instant('label.validation.min', { value: this.userTimePipe.transform(error?.min) });
  }
}
